<template>
  <crud-form
    ref="crudForm"
    v-model="payload"
    :page-title="$t('app.profile.add')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Profile"
    navigate-page-after-save="Profile"
    remove-cancel
    :override-create-payload="overrideCreatePayload"
    override-success-toas-message-create="Senha alterada com sucesso."
    :override-after-save="overrideAfterSave"
  >
    <template slot="group-1">
      <form-group :title="$t('app.profile.form.subtitle')">
        <v-flex
          xs12
          lg6
        >
          <input-password
            v-model="payload.current"
            input-key="currentPassword"
            required
            :rules="[passwordLength, currentPasswordComputed]"
            :label="$t('app.profile.form.current')"
          />
          <input-password
            v-model="payload.new"
            input-key="newPassword"
            required
            :rules="[passwordLength, newPasswordComputed]"
            :label="$t('app.profile.form.new')"
          />
          <input-password
            v-model="payload.confirmation"
            input-key="newPasswordConfirmation"
            required
            :rules="[passwordConfirmationComputed]"
            :label="$t('app.profile.form.confirmation')"
          />
        </v-flex>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import InputPassword from 'Support/components/inputs/InputPassword.vue';
import FormGroup from 'Support/layout/FormGroup.vue';
import CrudForm from 'Support/components/crud/CrudForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import ProfileRequest from 'Domain/profile/ProfileRequest';

export default {
  name: 'ProfileForm',
  components: {
    CrudForm,
    FormGroup,
    InputPassword,
  },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: ProfileRequest,
    payload: {
      current: '',
      new: '',
      confirmation: '',
    },
  }),
  computed: {
    newPasswordComputed() {
      return v => this.differsFromField(
        v,
        this.payload.current,
        'support.components.inputs.identical',
      ) || this.equalsToField(
        v,
        this.payload.confirmation,
        'support.components.inputs.confirmationError',
      );
    },
    passwordConfirmationComputed() {
      return v => this.equalsToField(
        v,
        this.payload.new,
        'support.components.inputs.confirmationError',
      );
    },
    currentPasswordComputed() {
      return v => this.differsFromField(
        v,
        this.payload.new,
        'support.components.inputs.identical',
      );
    },
  },
  methods: {
    overrideAfterSave() {
      this.payload.confirmation = '';
      this.payload.new = '';
      this.payload.current = '';
      this.$refs.crudForm.$refs.form.resetValidation();
    },
    overrideCreatePayload(payload) {
      return {
        confirmacaoSenha: payload.confirmation,
        novaSenha: payload.new,
        senhaAtual: payload.current,
      };
    },
  },
};
</script>
